var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNumber05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2703_57390)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.054 28.5654C18.8829 28.5654 17.8389 28.3499 16.9219 27.919C16.0104 27.4882 15.2868 26.8943 14.7509 26.1376C14.2151 25.3808 13.9362 24.5135 13.9141 23.5358H17.3942C17.4328 24.1931 17.709 24.7262 18.2228 25.135C18.7365 25.5437 19.3469 25.7481 20.054 25.7481C20.6174 25.7481 21.1146 25.6238 21.5455 25.3752C21.9819 25.1211 22.3216 24.7704 22.5646 24.3229C22.8132 23.87 22.9375 23.3507 22.9375 22.7652C22.9375 22.1686 22.8104 21.6438 22.5563 21.1908C22.3078 20.7379 21.9625 20.3843 21.5206 20.1302C21.0787 19.8761 20.5732 19.7463 20.0043 19.7408C19.5071 19.7408 19.0238 19.843 18.5542 20.0474C18.0902 20.2517 17.7284 20.5307 17.4688 20.8842L14.2786 20.3125L15.0824 11.3636H25.4564V14.2969H18.0405L17.6013 18.5476H17.7008C17.9991 18.1278 18.4493 17.7798 19.0514 17.5036C19.6535 17.2274 20.3274 17.0893 21.0732 17.0893C22.0951 17.0893 23.0065 17.3296 23.8075 17.8101C24.6085 18.2907 25.241 18.9508 25.705 19.7905C26.169 20.6246 26.3983 21.5858 26.3928 22.674C26.3983 23.8175 26.1331 24.8339 25.5973 25.7233C25.067 26.6071 24.324 27.3031 23.3684 27.8113C22.4182 28.314 21.3134 28.5654 20.054 28.5654Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2703_57390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNumber05);
export default __webpack_public_path__ + "static/media/icon-number-05.5b257d1220d4b88597df63c9ed2a9115.svg";
export { ForwardRef as ReactComponent };